<template>
  <div class="select" :class="{ 'is-disabled': disabled }">
    <select :id @change="onChange" :disabled class="u-full-width">
      <option v-if="nullable" :value="null">
        <slot name="nullOption"/>
      </option>
      <option v-for="(option, index) in options" :key="index" :value="index" :selected="value === option">
        <slot name="option" :option>
          {{ option }}
        </slot>
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
  type Option = any;

  const emit = defineEmits<{
    (e: 'input', value: Option): void,
  }>();

  const props = defineProps<{
    options: Array<Option>,
    disabled?: boolean,
    nullable?: boolean,
    id?: string,
  }>();

  const value = defineModel('value');

  function onChange($event: any) {
    const newValue = props.options[$event.target.value];
    emit('input', newValue);
    value.value = newValue;
  }
</script>
